import { ButtonBasic } from "@lk-gtcom/ecomlab-components";
import { useRef } from "react";
import customHeaders, { getSpace } from '../../../common/headers';
import useGeneralStore from "../../../store/general";
import { useResponseHandler } from "../../../common/auth";
import './ModalSummaryCrm.scss'
import { useState, useEffect } from "react";
import { Checkbox, Tabs, DropDownSelector, RangeBox } from "@lk-gtcom/ecomlab-components";
import { useDataTable } from "../../../common/hooks";
import { periodWeek } from "../../../common/constant";
import { msToLocalDate } from "../../../common/constant";
import { usePushNotifications } from "../../../common/pushNotification";
import { ModalComponent } from "../../../components/Modal/ModalComponent/ModalComponent";

const BTN_TAB = [
    { label: 'По проекту', value: 'project' },
    { label: 'По воронке', value: 'funnel' }
];

const ModalSummaryCrm = ({
    setIsModal,
    taskId,
    selectedExecutor,
    selectedAuthor,
    selectedCoExecutor
}) => {

    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleTableResponse, handleRequestError } = useResponseHandler();
    // Обработка ошибок
    const { addErrorPush, addSuccessPush } = usePushNotifications();

    const [pageValue, setPageValue] = useState(BTN_TAB[0]?.value);
    const [fields, setFields] = useState([]);
    const [selectedFields, setSelectedFields] = useState([]); // Массив объектов {name, field}
    const [isAdditionalField, setIsAdditionalField] = useState(false)

    const [date, setDate] = useState(periodWeek());
    let [date_from, date_to] = date;

    const [dataFunnel, setDataFunnel] = useState([])
    const [selectedFunnel, setSelectedFunnel] = useState(null)

    const [dataOperator, setDataOperator] = useState([])
    const [selectedOperator, setSelectedOperator] = useState(null)

    // ==================== ТАБЛИЦА ====================
    const paginatorRef = useRef();
    const [setTable, tableProps, setTableFuncs] = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    );
    const [tableData, setTableData] = useState([]);
    const { setLoading } = setTableFuncs;
    const { filters, sort } = tableProps

    // Получение полей
    const fetchGetField = () => {

        let url = `https://portals.ecomru.ru/api/crm/deals/pivot_table/fields/by_project`;
        if (pageValue === 'funnel') {
            url = `https://portals.ecomru.ru/api/crm/deals/pivot_table/fields/by_funnel?funnel_id=${selectedFunnel?.value}`
        }

        fetch(url, { headers })
            .then(handleTableResponse)
            .then((json) => {
                const fieldsData = json?.fields || [];
                setFields(fieldsData);
                setDataOperator(json?.operators.map(el => ({ label: el, value: el })))
            })
            .catch(handleRequestError);
    };

    // Получение воронок
    const fetchGetBord = () => {
        let url = `https://portals.ecomru.ru/api/crm/funnels/${taskId}?page=1&limit=10000`

        fetch(url, { headers })
            .then(handleTableResponse)
            .then((json) => {
                setDataFunnel(json?.data?.map(({ id, name }) => ({ label: name, value: id })));
            })
            .catch(handleRequestError);
    };

    // Функция для скачивания файла
    const downloadFile = (blob, filename) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    };

    // Скачать отчет
    const fetchDownload = (params, abortController = new AbortController()) => {
        let _sort;
        let filtersParam;

        if (params) {
            [_sort, filtersParam] = params;
        }
        setLoading(true);

        let url = `https://portals.ecomru.ru/api/crm/deals/pivot_table/by_project/${taskId}`
        if (pageValue === 'funnel') {
            url = `https://portals.ecomru.ru/api/crm/deals/pivot_table/by_funnel/${selectedFunnel?.value}`
        }

        const body = JSON.stringify({
            limit: paginatorRef?.current?.limit || 10,
            page: paginatorRef?.current?.page || 1,
            order_field: _sort?.[0] || sort?.[0],
            responsible_list: selectedExecutor?.length > 0 ? selectedExecutor : [],
            author_list: selectedAuthor?.length > 0 ? selectedAuthor : [],
            co_executors_list: selectedCoExecutor?.length > 0 ? selectedCoExecutor : [],
            order_direction: _sort?.[1] || sort?.[1],
            filters: Array.isArray(filtersParam) ? filtersParam : filters,
            fields: selectedFields,
            operators: selectedOperator?.value,
            show_additional_field: isAdditionalField,
            date_from: msToLocalDate(date_from),
            date_to: msToLocalDate(date_to),
        });

        fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            body,
            signal: abortController.signal
        })
            .then(async (response) => {
                if (!response.ok) {
                    if (response.status === 400) {
                        const errorData = await response.json().catch(() => ({}));
                        addErrorPush(`Ошибка 400: ${errorData}`);
                        throw new Error(errorData.message || 'Ошибка 400');
                    }

                    const errorData = await response.json().catch(() => ({}));
                    throw new Error(errorData.message || `Ошибка ${response.status}`);
                }

                const blob = await response.blob();

                const contentDisposition = response.headers.get('Content-Disposition');
                let filename = `отчет_${new Date().toISOString().slice(0, 10)}.xlsx`;

                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1].replace(/['"]/g, '');
                    }
                }

                downloadFile(blob, filename);
                // setIsModal(false);
            })
            .catch((error) => {
                if (abortController.signal.aborted) return;
                handleRequestError(error);
            })
            .finally(() => {
                if (abortController.signal.aborted) return
                setLoading(false)
            })
    };

    useEffect(() => {
        setSelectedFields([]);
        setFields([]);
        fetchGetField()
    }, [pageValue, selectedFunnel]);

    useEffect(() => {
        if (pageValue === 'funnel') {
            fetchGetBord()
        }
    }, [pageValue]);

    const handleCheckboxChange = (fieldObj) => {
        setSelectedFields(prev => {
            // Проверяем, есть ли уже такой объект в массиве по полю field
            const exists = prev.some(item => item.field === fieldObj.field);

            if (exists) {
                // Если поле уже выбрано - удаляем его
                return prev.filter(item => item.field !== fieldObj.field);
            } else {
                // Если поле не выбрано - добавляем его
                return [...prev, fieldObj];
            }
        });
    };

    return (
        <ModalComponent
            title="Выгрузить отчет"
            onClose={(e) => setIsModal(false)}
            style={{maxWidth: '800px'}}
            child={
                <div className='modal-summary-crm__content'>

                    <Tabs
                        tabs={BTN_TAB}
                        pageValue={pageValue}
                        spanTab
                        setPageValue={setPageValue}
                    />

                    {(pageValue === 'funnel') &&
                        <div className="modal-summary-crm__field-group">
                            <DropDownSelector
                                options_prop={dataFunnel}
                                state={selectedFunnel}
                                setState={setSelectedFunnel}
                                placeholder="Выберите воронку"
                                required
                            />

                            <DropDownSelector
                                options_prop={dataOperator}
                                state={selectedOperator}
                                setState={setSelectedOperator}
                                placeholder="Выберите оператор"
                                required
                            />
                        </div>
                    }

                    <RangeBox
                        date={date}
                        setDate={setDate}
                    />

                    <Checkbox
                        value={isAdditionalField}
                        onChange={() => setIsAdditionalField(!isAdditionalField)}
                    >
                        Учитывать дополнительные поля
                    </Checkbox>

                    <div className='modal-summary-crm__content'>
                        <div className='modal-summary-crm__checkbox'>
                            {fields.map((fieldObj) => {
                                return (
                                    <Checkbox
                                        key={fieldObj.field}
                                        value={selectedFields.some(item => item.field === fieldObj.field)}
                                        onChange={() => handleCheckboxChange(fieldObj)}
                                    >
                                        {fieldObj.name}
                                    </Checkbox>
                                );
                            })}
                        </div>

                        <ButtonBasic
                            blue
                            style={{ minHeight: '40px' }}
                            text='Скачать'
                            onClick={() => fetchDownload()}
                            disabled={(pageValue === 'funnel') && (!selectedFunnel?.value || !selectedOperator?.value)}
                            fullWidth
                        />
                    </div>
                </div>
            }
        />
    )
}

export { ModalSummaryCrm }